import { ReactNode } from 'react'
import { Provider } from 'react-redux'
import { AppStore } from './AppStore'

export function AppStoreProvider({ children }: { children: ReactNode }) {
  return <Provider store={AppStore}>{children}</Provider>
}
